export type Reader = {
  name: string
  location: string
}

export const readers: Reader[] = [
  {
    name: 'Diego N.',
    location: 'Ciudad de México, México',
  },
  {
    name: 'Camila R.',
    location: 'Medellín, Colombia',
  },
  {
    name: 'Javier F.',
    location: 'Santiago, Chile',
  },
  {
    name: 'Daniela V.',
    location: 'Lima, Perú',
  },
  {
    name: 'Alejandro M.',
    location: 'Madrid, España',
  },
  {
    name: 'Mariana P.',
    location: 'Montevideo, Uruguay',
  },
  {
    name: 'Sebastián A.',
    location: 'Quito, Ecuador',
  },
  {
    name: 'Laura J.',
    location: 'San José, Costa Rica',
  },
  {
    name: 'Martín G.',
    location: 'Buenos Aires, Argentina',
  },
  {
    name: 'Valentina O.',
    location: 'Guadalajara, México',
  },
  {
    name: 'Andrés C.',
    location: 'Bogotá, Colombia',
  },
  {
    name: 'Paula H.',
    location: 'Barcelona, España',
  },
  {
    name: 'Rodrigo C.',
    location: 'Asunción, Paraguay',
  },
  {
    name: 'Fernanda S.',
    location: 'Ciudad de Panamá, Panamá',
  },
  {
    name: 'Emilio V.',
    location: 'Ciudad de Guatemala, Guatemala',
  },
  {
    name: 'Lucía D.',
    location: 'Santo Domingo, República Dominicana',
  },
  {
    name: 'Tomás E.',
    location: 'Valencia, España',
  },
  {
    name: 'Gabriela M.',
    location: 'Monterrey, México',
  },
]
